import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPenStyle0 = gravityIconIndividualCss;

const GravityIconPen = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '07e9309a59037be0227aefeaa3659b5f2d1162af', color: this.color, size: this.size }, h("svg", { key: '35c4e19dca4026a78e0b03edc8b8fb7a88bdb71c', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'd6175ff19b368e02acdeeb4ee9af84ccac50e957', d: "M5.213 13.899 12.99 6.12l2.828 2.829-7.778 7.778-3.323 1.075a.5.5 0 0 1-.627-.639L5.213 13.9Zm13.081-8.132c.195.195.222.485.06.648L16.88 7.888 14.052 5.06l1.473-1.473c.162-.163.453-.137.648.059l2.121 2.12Z", fill: "currentColor" }))));
    }
};
GravityIconPen.style = GravityIconPenStyle0;

export { GravityIconPen as gravity_icon_pen };

//# sourceMappingURL=gravity-icon-pen.entry.js.map